import { Button, FormControl, Input, InputLabel } from '@mui/material';

import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

import { LiftStatusStorage } from 'Utils/Storage';

import { $api, ApiError, unwrap } from '~/lib/api-client';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import classes from '../styles/Login.module.scss';

const Login = () => {
  const intl = useIntl();

  const navigate = useNavigate();

  const [usernameState, setUsernameState] = useState<string>('');
  const [passwordState, setPasswordState] = useState<string>('');

  const loginMutation = useMutation({
    mutationFn: async (payload: { username: string; password: string }) => {
      const data = await unwrap(
        $api['/liftstatus/auth'].POST({ body: payload })
      );

      // Dual-mode API returns { accessToken }; the cookie-only API returns 204
      return { accessToken: data?.accessToken };
    },
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) {
        toast.error(intl.formatMessage({ id: 'login.failed' }));
        return;
      }

      toast.error(`Login error: ${error.message}`);
    },
    onSuccess: ({ accessToken }) => {
      if (accessToken) {
        LiftStatusStorage.userToken = accessToken;
      }

      const deepLinkEventId = localStorage.getItem('deep-link-event-id');

      if (deepLinkEventId) {
        navigate(`/events/${deepLinkEventId}`);
      } else {
        navigate('/dashboard');
      }
    },
  });

  const handleLogin = () => {
    if (!passwordState) {
      toast.error(intl.formatMessage({ id: 'login.password.required' }), {
        type: 'error',
        position: 'top-left',
      });
      return;
    }

    loginMutation.mutate({
      username: usernameState,
      password: passwordState,
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;

    if (name === 'password') {
      setPasswordState(value);
    } else {
      setUsernameState(value);
    }
  };

  return (
    <>
      <h3>
        <FormattedMessage id="login" />
      </h3>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
        className={classes.inputsWrapper}
      >
        <FormControl className={classes.username}>
          <InputLabel>
            <FormattedMessage id="username" />
          </InputLabel>
          <Input
            onChange={handleChange}
            name="username"
            value={usernameState}
          />
        </FormControl>

        <FormControl>
          <InputLabel>
            <FormattedMessage id="password" />
          </InputLabel>

          <Input onChange={handleChange} name="password" type="password" />
        </FormControl>

        <Button variant="outlined" color="primary" type="submit">
          <FormattedMessage id="login" />
        </Button>

        <span
          className={classes.resetPassword}
          onClick={() => navigate('/password-reset')}
        >
          <FormattedMessage id="forgot.password" />?
        </span>
      </form>
    </>
  );
};

export default Login;
